import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { GanttIcon } from '~/assets/icons';
import { Header } from '~/components/ui/Header';

import { ScheduleToolbar } from '../schedule/components/ScheduleToolbar';
import { useScheduleViewType } from '../schedule/libs/hooks/useScheduleViewType';

import { CalendarDayIcon, CalendarMonthIcon } from './Calendar.Icons';

interface CalendarHeaderProps {
  views: string[];
  onView: (view: string) => void;
  view: string;
}

export const CalendarHeader = (props: CalendarHeaderProps) => {
  const navigate = useNavigate();

  const [__, setViewType] = useScheduleViewType();

  const { t } = useTranslation('schedule');

  const options = props.views.map((view: string) => {
    switch (view) {
      case 'month':
        return {
          value: 'month',
          icon: <CalendarMonthIcon color="currentColor" size="20" />,
          label: t('schedule:m_month'),
        };
      case 'day':
      default:
        return {
          value: 'day',
          icon: <CalendarDayIcon color="currentColor" size="20" />,
          label: t('schedule:m_day'),
        };
    }
  });

  return (
    <>
      <Header
        onBack={() => {
          if (props.view === 'day') {
            props.onView('month');
          } else {
            navigate(-1);
          }
        }}
      >
        {t('schedule:calendar')}
      </Header>

      <ScheduleToolbar>
        <ScheduleToolbar.Toggle
          icon={<GanttIcon />}
          onClick={() => {
            setViewType('GANTT');
            window.localStorage.setItem('scheduleType', 'GANTT');
          }}
        >
          {t('schedule:type_gantt')}
        </ScheduleToolbar.Toggle>

        <ScheduleToolbar.Segment
          value={props.view}
          options={options}
          onChange={(value) => {
            props.onView(value);
          }}
        />
      </ScheduleToolbar>
    </>
  );
};
